import { render, staticRenderFns } from "./EvaluationList.vue?vue&type=template&id=6cd729fe&scoped=true"
import script from "./EvaluationList.vue?vue&type=script&lang=js"
export * from "./EvaluationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd729fe",
  null
  
)

export default component.exports